(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react-redux"), require("classnames"), require("react"), require("redux"), require("@fiverr/i18n/singleton"), require("@fiverr/gofor"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react-redux", "classnames", "react", "redux", "@fiverr/i18n/singleton", "@fiverr/gofor", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["Reviews"] = factory(require("react-redux"), require("classnames"), require("react"), require("redux"), require("@fiverr/i18n/singleton"), require("@fiverr/gofor"), require("react-dom"));
	else
		root["Reviews"] = factory(root["ReactRedux"], root["classNames"], root["React"], root["Redux"], root["i18n"], root["goforFactory"], root["ReactDOM"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_H_qB__, __WEBPACK_EXTERNAL_MODULE_JgyH__, __WEBPACK_EXTERNAL_MODULE_Jmof__, __WEBPACK_EXTERNAL_MODULE_dJD___, __WEBPACK_EXTERNAL_MODULE_h4G9__, __WEBPACK_EXTERNAL_MODULE_jPm4__, __WEBPACK_EXTERNAL_MODULE_wLXD__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition